import { DATA_COLLECTION_CONFIGS } from "pages/dataCollection/_shared/config";
import { DataCollectionPage } from "pages/dataCollection/_shared/DataCollectionPage";

function Other() {
  return <DataCollectionPage config={DATA_COLLECTION_CONFIGS.other} />;
}

export default Other;
